import React from "react";

import useShowPollenNavStore from "../../../../../sp-state/useShowPollenNavStore";

import styles from "./TopicsMobileBtn.module.scss";

const TopicsMobileBtn = () => {
  const { showPollenNav, setShowPollenNav } = useShowPollenNavStore(
    state => state
  );
  const btnIcon = showPollenNav ? "chevron-up" : "chevron-down";
  const btnStyles = `${styles.topicsBtn} ${showPollenNav && styles.active}`;
  const handleClick = () => {
    setShowPollenNav(!showPollenNav);
  };

  return (
    <button className={btnStyles} onClick={handleClick}>
      topics
      <svg className={styles.topicsBtnIcon}>
        <use href={`/icons/chevrons.svg#${btnIcon}`}></use>
      </svg>
    </button>
  );
};

export default TopicsMobileBtn;
